import React from 'react'
import PropTypes from 'prop-types'
import { makeStyles } from '@material-ui/core'
import VisibilityOutlinedIcon from '@material-ui/icons/VisibilityOutlined'
import impersonationAlertStyles from './impersonationAlert.styles'
import useGetLocalStorage from '../../hooks/useGetLocalStorage'
import useEndSession from '../../hooks/useEndSession'
import { useMyLayout } from '../../context/useMyLayout'
import localStorageIds from '../../utils/constants/localStorageIds'

const useStyles = makeStyles(impersonationAlertStyles)

// Impersonation replaced the super user's tokens and refresh cookie, so stopping it is a logout.
const ImpersonationAlert = ({ sideBarOpen }) => {
  const classes = useStyles()
  const localStorageValue = useGetLocalStorage()
  const { [localStorageIds.IMPERSONATION]: impersonation } = localStorageValue || {}
  const { user } = useMyLayout()
  const endSession = useEndSession()

  if (!impersonation) return null

  if (!sideBarOpen)
    return (
      <div className={classes.collapsed} title='Impersonating a user'>
        <VisibilityOutlinedIcon fontSize='small' />
      </div>
    )

  const name = `${user?.firstName ?? ''} ${user?.lastName ?? ''}`.trim()

  return (
    <div className={classes.panel}>
      <span className={classes.eyebrow}>
        <VisibilityOutlinedIcon className={classes.eyebrowIcon} />
        Impersonating
      </span>
      <div className={classes.user}>
        {name && <span className={classes.name}>{name}</span>}
        <span className={classes.email}>{user?.email}</span>
      </div>
      <button type='button' className={classes.stop} onClick={endSession}>
        Stop impersonating
      </button>
    </div>
  )
}

ImpersonationAlert.propTypes = {
  sideBarOpen: PropTypes.bool,
}

export default ImpersonationAlert
